<template>
  <b-dropdown ref="columnFiltersDropdown" class="m-0 p-0" size="micro" :variant="currentFilter[2].length > 0 ? 'success' : 'dark'" no-caret>
    <template #button-content>
      <font-awesome-icon icon="filter" />
    </template>
    <b-dropdown-form @submit.prevent.stop="addFilter" style="width: 450px">
      <b-button-toolbar>
        <b-input-group size="sm">
          <b-input-group-prepend>
            <b-form-text class="mr-1 text-truncate" style="max-width: 120px;">{{filter.label}}</b-form-text>
          </b-input-group-prepend>
          <b-form-select v-model="currentFilter[1]" :options="filterOptions" style="width: 10px !important;" />
          <b-form-input v-model="currentFilter[2]" class="text-right"></b-form-input>
        </b-input-group>
        <b-button-group size="sm" class="ml-1">
          <b-button variant="success" type="submit">Apply</b-button>
          <b-button variant="danger" @click.prevent="deleteFilter">✕</b-button>
        </b-button-group>
      </b-button-toolbar>
    </b-dropdown-form>
  </b-dropdown>
</template>

<script>
export default {
  emits: ['apply-filters'],
  name: 'ColumnFilters',
  props: {
    type: {
      type: String,
      default: ''
    },
    filter: {
      type: Object,
      required: true
    },
    noQuerystring: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentFilter: [],
      currentFilters: []
    }
  },
  computed: {
    filterOptions() {
      return [
        {
          value: 'ct',
          text: this.$gettext('Contains')
        },
        {
          value: 'sw',
          text: this.$gettext('Starts with')
        },
        {
          value: 'ew',
          text: this.$gettext('Ends with')
        },
        {
          value: 'eq',
          text: this.$gettext('Equals')
        },
        {
          value: 'gt',
          text: this.$gettext('Greater than')
        },
        {
          value: 'gte',
          text: this.$gettext('Greater than or equalTo')
        },
        {
          value: 'lte',
          text: this.$gettext('Lesser than or equalTo')
        },
        {
          value: 'lt',
          text: this.$gettext('Lesser than')
        },
        {
          value: 'in',
          text: this.$gettext('In array')
        },
        {
          value: 'bt',
          text: this.$gettext('Between')
        }
      ]
    }
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler() {
        this.init()
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init() {
      if (this.$route.query.af) {
        this.currentFilters = JSON.parse(this.$route.query.af)
        for (const currentFilter of this.currentFilters) {
          if (this.filter.key === currentFilter[0]) {
            this.currentFilter = currentFilter
            return
          } else {
            this.currentFilter = [this.filter.key, 'ct', '']
          }
        }
      } else {
        this.currentFilter = [this.filter.key, 'ct', '']
      }
    },
    addFilter() {
      const index = this.currentFilters.findIndex(x => x[0] === this.currentFilter[0])
      if (index !== -1) {
        this.currentFilters[index] = this.currentFilter
      } else {
        this.currentFilters.push(this.currentFilter)
      }
      this.applyFilters({ filtersToEmit: this.currentFilters })
    },
    deleteFilter() {
      const index = this.currentFilters.findIndex(x => x[0] === this.currentFilter[0])
      this.currentFilters.splice(index, 1)
      this.applyFilters({ filtersToEmit: this.currentFilters })
    },
    applyFilters(filters) {
      this.$refs.columnFiltersDropdown.hide(true)
      if (!this.noQuerystring) {
        this.$router.push({ query: this.currentFilters.length > 0 ? { af: JSON.stringify(this.currentFilters) } : null })
      }
      this.$emit('apply-filters', filters)
      this.$root.$emit('activeFilters', filters?.filtersToEmit.length)
      this.$root.$emit('bv::refresh::table', this.type)
    }
  }
}
</script>

<style lang="scss">
.btn-micro, .btn-group-micro > .btn {
  padding: 0.1rem 0.25rem !important;
  font-size: 0.5rem !important;
  line-height: 1.5 !important;
  border-radius: 0.2rem !important;
}
</style>